export default class BinanceCurrencyResponse {
    constructor(
        public symbol: string,
        public precision: number,
    ) {
    }
}
